import { type RefObject, useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';

import { MAX_ZOOM_OUT } from '@/utils/constants/map';

const useGetCurrentZoom = (): { currentZoom: RefObject<number> } => {
  const { current: mapRef } = useMap();

  const currentZoom = useRef(mapRef?.getZoom() || MAX_ZOOM_OUT);

  useEffect(() => {
    if (!mapRef) {
      return;
    }

    const handleZoom = () => {
      currentZoom.current = mapRef.getZoom();
    };

    mapRef.on('zoom', handleZoom);

    return () => {
      mapRef.off('zoom', handleZoom);
    };
  }, [mapRef]);

  return { currentZoom };
};
export default useGetCurrentZoom;
